export const CROP_CYCLE_COPY_OPTIONS = [
  { id: 1, label: 'Previous Crop Cycle' },
  { id: 2, label: 'Current Crop Cycle' },
]

export const CTAS = {
  DELETE_CYCLE: 'Delete Cycle',
}

export const PLACEHOLDER = {
  CROP_CYCLE: 'Select Crop Cycle',
}

export const SUPPLIER_TYPES = {
  EXPORT: 'Export',
  DOMESTIC: 'Domestic',
  DOMESTIC_PROPRIETARY: 'DomesticProprietary',
  IMPORT_PROPRIETARY: 'ImportProprietary',
  DOMESTIC_MARKET: 'DomesticMarket',
}

export const formatProgramName = (name) => (name ? name?.replace(/([a-z])([A-Z])/g, '$1 $2') : '')
